// extracted by mini-css-extract-plugin
export default {"card":"DisplaySlots_card__T+ywF","date":"DisplaySlots_date__gjxD6","calendar-icon":"DisplaySlots_calendar-icon__ZJkNn"};